import { Link } from "react-router-dom";

const categories = [
  { id: 1, name: "Ephemera & Papers", description: "Vintage papers, book pages, sheet music, maps, and decorative ephemera packs", icon: "ri-file-paper-2-line", image: "https://public.readdy.ai/ai/img_res/a52b74d47530ad97bd005cdb086f7984.jpg" },
  { id: 2, name: "Washi Tape", description: "Decorative washi tapes in every pattern — floral, vintage, geometric, and seasonal", icon: "ri-scissors-cut-line", image: "https://readdy.ai/api/search-image?query=colorful%20washi%20tape%20rolls%20collection%20flat%20lay%20craft%20supplies%20pastel%20tones%20aesthetic&width=300&height=200&seq=cat2&orientation=landscape" },
  { id: 3, name: "Stamps & Ink", description: "Rubber stamps, clear stamps, ink pads, and embossing powders for journaling", icon: "ri-ink-bottle-line", image: "https://readdy.ai/api/search-image?query=rubber%20stamps%20ink%20pads%20craft%20supplies%20close%20up%20warm%20tones%20artistic%20flat%20lay&width=300&height=200&seq=cat3&orientation=landscape" },
  { id: 4, name: "Stickers & Die Cuts", description: "Watercolor stickers, foil die cuts, and decorative labels for embellishing", icon: "ri-star-line", image: "https://readdy.ai/api/search-image?query=watercolor%20stickers%20die%20cuts%20decorative%20labels%20craft%20supplies%20colorful%20flat%20lay%20aesthetic&width=300&height=200&seq=cat4&orientation=landscape" },
  { id: 5, name: "Snail Mail Kits", description: "Complete pen pal kits, letter sets, envelopes, and postage-inspired accessories", icon: "ri-mail-line", image: "https://readdy.ai/api/search-image?query=snail%20mail%20pen%20pal%20kit%20envelopes%20letter%20sets%20stationery%20flat%20lay%20warm%20cream%20tones&width=300&height=200&seq=cat5&orientation=landscape" },
  { id: 6, name: "Journal Kits & Bundles", description: "Pre-assembled junk journal kits with papers, tags, pockets, and embellishments", icon: "ri-book-open-line", image: "https://readdy.ai/api/search-image?query=junk%20journal%20kit%20bundle%20papers%20tags%20pockets%20embellishments%20flat%20lay%20vintage%20aesthetic&width=300&height=200&seq=cat6&orientation=landscape" },
  { id: 7, name: "Fabric & Textiles", description: "Fabric scraps, lace, ribbon, and textile embellishments for mixed media", icon: "ri-scissors-2-line", image: "https://readdy.ai/api/search-image?query=fabric%20scraps%20lace%20ribbon%20textile%20embellishments%20craft%20supplies%20warm%20earthy%20tones&width=300&height=200&seq=cat7&orientation=landscape" },
  { id: 8, name: "Tools & Supplies", description: "Bone folders, punches, adhesives, and essential tools for the craft", icon: "ri-tools-line", image: "https://readdy.ai/api/search-image?query=craft%20tools%20bone%20folder%20punches%20adhesives%20supplies%20flat%20lay%20warm%20tones%20artisan&width=300&height=200&seq=cat8&orientation=landscape" },
];

export default function CategoriesSection() {
  return (
    <section className="py-20 bg-[#3a2410]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-[#f0c87a] text-xs font-semibold uppercase tracking-widest mb-4">
              <i className="ri-grid-line"></i>
              Browse by Category
            </div>
            <h2 className="text-4xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
              Shop By Creative Category
            </h2>
            <p className="text-[#c9a87c] mt-2 max-w-lg">
              From vintage ephemera to handmade journals — explore {categories.length} curated categories of junk journal and snail mail supplies.
            </p>
          </div>
          <Link
            to="/categories"
            className="flex items-center gap-2 text-sm font-medium text-[#f0c87a] hover:text-white transition-colors whitespace-nowrap"
          >
            Browse all categories
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?cat=${encodeURIComponent(cat.name)}`}
              className="group relative rounded-xl overflow-hidden bg-[#4a3020] border border-white/10 hover:border-[#c9a87c]/50 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="h-32 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2c1a0a]/80 via-transparent to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-5 h-5 flex items-center justify-center text-[#c9a87c]">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <h3 className="font-semibold text-white text-sm leading-tight">{cat.name}</h3>
                </div>
                <p className="text-xs text-[#a89880] leading-relaxed line-clamp-2">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
